import Vue from "vue";
import Component from "vue-class-component";
import $ from "jquery";
import moment from "moment";
import { ServicesFactoryInstance } from "../../Controls/ServicesFactory";
import { ParametresInstance } from "../../Controls/Parameters";
import { EventBus } from "../../Controls/EventBus";
import { DemandeEditionTableauDto } from "../../../dto/GenApi.iNotPaie.Dto/DemandeEditionTableauDto";
import { TableauDto } from "../../../dto/GenApi.iNotPaie.Dto/TableauDto";
import { ExerciceDto } from "../../../dto/GenApi.iNotPaie.Dto/ExerciceDto";
import EventConstants from "../../Controls/EventConstants";
import { NotificationServiceInstance } from "../../../shared/services/notification.service";

@Component
export default class ModalEditionTableau extends Vue {
	public idEdition = 0;
	public libelleEdition = "";
	public typeEdition = "I";
	public codeTypeTableau = "";
	public sousTotaux = "A";
	public detailMensuel = false;
	public totalAnnuel = false;
	public exportExcel = false;
	public miseEnGed = false;

	public startYear = "2018";
	public startMonth = "3";
	public endMonth = "3";
	public endYear = "2018";

	public listeAnnee: number[] = [];
	public exercices: ExerciceDto[] = [];
	public exercicesFiltred: ExerciceDto[] = [];
	public selectedExercice?: ExerciceDto = undefined;
	public dataReady = true;
    public editionEnCours = false;
    public libelleDetail: string = "Détail mensuel";

	public mounted(): void {
    	this.initConstantes();
    	EventBus.$on(EventConstants.SOCIETE_CHANGED, () => {
    		this.initConstantes();
    	});
	}

	public initConstantes(): void {
    	ServicesFactoryInstance.ExercicesService.getExercices(data => {
    		this.exercices = data;
    		this.doFilter();
    		this.listeAnnee = this.exercices.map(e => e.Annee).filter((value, index, self) => self.indexOf(value) == index).sort((a, b) => b - a);
    	});
	}

	public doFilter(): void {
    	this.exercicesFiltred = this.exercices.filter(e => e.Annee == Number(this.startYear)).sort((a, b) => b.Mois - a.Mois);
    	this.selectedExercice = this.exercicesFiltred[0];
	}

	public selectExercice(exercice: ExerciceDto): void {
    	this.selectedExercice = exercice;
    	this.$forceUpdate();
	}

	public Init(tableau: TableauDto): void {
    	this.idEdition = tableau.Id;
    	this.libelleEdition = tableau.TitreEdition != undefined ? tableau.TitreEdition : "";
    	this.typeEdition = tableau.TypeEdition != undefined ? tableau.TypeEdition : "G";
    	this.sousTotaux = tableau.SousTotaux != undefined ? tableau.SousTotaux : "A";
    	this.codeTypeTableau = tableau.CodeTypeTableau != undefined ? tableau.CodeTypeTableau : "";
    	this.detailMensuel = tableau.DetailMensuel;
    	this.totalAnnuel = tableau.TotalAnnuel;
    	this.exportExcel = false;
    	this.miseEnGed = false;

    	if (this.codeTypeTableau == "B") {
    		this.typeEdition = "U";
    	}

    	if (ParametresInstance.societeCourante != undefined && ParametresInstance.societeCourante.DernierExercice) {
    		this.startMonth = moment.utc(ParametresInstance.societeCourante.DernierExercice).toDate().getUTCMonth().toString();
    		this.endMonth = this.startMonth;
    		this.startYear = moment.utc(ParametresInstance.societeCourante.DernierExercice).toDate().getUTCFullYear().toString();
    		this.endYear = this.startYear;
        }

        this.initLibelle();

    	this.doFilter();
    	this.$forceUpdate();
    }

    public initLibelle(): void {
        switch (this.codeTypeTableau) {
            case "D":
                this.libelleDetail = "Détail salariés";
                break;
            default:
                this.libelleDetail = "Détail mensuel";
                break;
        }
    }

	public annuler(): void {
    	$("#modalEditionTableau").modal("hide");
	}

	public LancerEdition(): void {
    	const demande: DemandeEditionTableauDto = {
    		AnneeDebut: Number(this.startYear),
    		AnneeFin: Number(this.endYear),
    		IdTableau: this.idEdition,
    		MoisDebut: Number(this.startMonth) + 1,
    		MoisFin: Number(this.endMonth) + 1,
    		detailMensuel: this.detailMensuel,
    		libelleEdition: this.libelleEdition,
    		sousTotaux: this.sousTotaux,
    		totalAnnuel: this.totalAnnuel,
    		typeEdition: this.typeEdition,
    		exportExcel: this.exportExcel,
    		miseEnGed: this.miseEnGed,
    		UserName: ParametresInstance.utilisateurCourant != undefined ? ParametresInstance.utilisateurCourant.Intitule : "",
    		CodeSociete: ParametresInstance.societeCourante != undefined ? ParametresInstance.societeCourante.Code : "",
    		CodeTypeTableau: this.codeTypeTableau,
    		IdsContrat: []
    	};

    	if (this.codeTypeTableau == "J") {
    		if (this.selectedExercice != undefined) {
    			demande.MoisDebut = this.selectedExercice.Mois;
    		}
    		demande.MoisFin = demande.MoisDebut;
    		demande.AnneeFin = demande.AnneeDebut;
    	}

    	$("#modalEditionTableau").modal("hide");
    	if (this.codeTypeTableau == "D") {
    		this.$emit("openDeclarationCharges", demande);
    	} else if (this.typeEdition == "U") {
    		this.$emit("viewListSalarie", demande);
    	} else if (this.codeTypeTableau == "J") {
    		this.$emit("openJournal", demande);
    	} else {
    		NotificationServiceInstance.SendSuccess("La demande d'édition a été prise en compte. Le document sera bientôt disponible");
    		ServicesFactoryInstance.EditionsService.getEditionTableau(demande, (r: Blob) => {
    			const libelle = this.libelleEdition + (demande.CodeTypeTableau == "B" ? ".doc" : (this.exportExcel ? ".xlsx" : ".pdf"));

    			if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    				window.navigator.msSaveOrOpenBlob(r, libelle);
    				this.dataReady = true;
    			} else {
    				this.dataReady = true;

    				const link = document.createElement("a");
    				document.body.appendChild(link);

    				link.href = window.URL.createObjectURL(r);
    				link.download = libelle;
    				link.click();

    				NotificationServiceInstance.SendSuccess(`L'édition de la liste '${this.libelleEdition}' s'est correctement déroulée !`);
    			}
    		});
    	}
	}
}




// WEBPACK FOOTER //
// ./src/components/tableaux/modalEditionTableau/modalEditionTableau.ts